// @flow weak

import _ from 'lodash/fp';
import uuid from 'uuid';
import {
  ADD,
  REMOVE,
} from '../actions/notification';

const newNotification = (message, level = 'success') => ({
  id: uuid.v4(),
  message,
  level,
});

const notification = (state = [], action) => {
  switch (action.type) {
    case ADD:
      return [
        ...state,
        newNotification(action.message, action.level),
      ];
    case REMOVE:
      return _.reject({id: action.id}, state);
    default:
      const notification = action[ADD];
      if (notification) {
        return [
          ...state,
          newNotification(notification.message, notification.level),
        ];
      }
      return state;
  }
};

export default notification;



// WEBPACK FOOTER //
// ./src/reducers/notifications.js